import { ParamMap } from '@angular/router';
import { EmitData } from './../../../fam/serves/event-listener.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { SwHttpClientService } from '../../../../librarys/serves/sw-http-client.service';
import { HttpClient } from '@angular/common/http';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { EntrustmentContractInformationSave } from '../../services/entrustment-contract-information';

@Injectable({
  providedIn: 'root'
})
/**
 * 项目管理service
 */
export class ProjectManageService {
  prefix: string = environment.apmWebAPI;
  // 后端微服务famWebAPI地址
  famfix: string = environment.famWebAPI;

  constructor(
    private httpClient: HttpClient,
    private message: SwMassageBoxService, //消息提示
    private http: SwHttpClientService
  ) { }

  /**
   * 主键查询项目表信息
   */
  queryProjectById(param: any) {
    const url = this.prefix + 'Project/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 主键查询项目表信息, 包含勘探、发掘、合同等信息
   */
  queryProjectInfoById(id: any) {
    const url = this.prefix + 'Project/queryProjectInfoById/' + id;
    return this.http.Get(url);
  }

  /**
   * 分页查询项目表信息
   */
  queryProjectPageList(param: any) {
    const url = this.prefix + 'Project/queryPageList';
    return this.http.Post(url, param);
  }

  /**
 * 分页查询合同选择下的项目表信息
 */
  queryContractProjectPageList(param: any) {
    const url = this.prefix + 'Project/queryContractPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查询所有项目表信息
   */
  queryProjectList(entity: any) {
    const url = this.prefix + 'Project/queryList';
    return this.http.Post(url, entity);
  }

  /**
 * 查询所有项目表信息
 */
  querySimpleList(entity: any) {
    const url = this.prefix + 'Project/querySimpleList';
    return this.http.Post(url, entity);
  }


  /**
   * 根据新项目的名称检索具有相似率的过往项目
   * @param param 参数
   * @returns 项目列表
   */
  getProjectList(params: any) {
    const url = this.prefix + 'Project/getOldProjects';
    return this.http.Post(url, params);
  }

  /**
 * 查询项目档案号
 */
  getDocumentNo() {
    const url = this.prefix + 'Project/getDocumentNo';
    return this.http.Get(url);
  }

  /**
   * 新增项目表信息
   */
  saveProject(param: any) {
    const url = this.prefix + 'Project/save';
    return this.http.Post(url, param);
  }


  /**
   * 更新项目表信息
   */
  updateProjectById(param: any) {
    const url = this.prefix + 'Project/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 工作流模块调用
   * @param param 包含更新字段的对象
   */
  updateByIdForWorkFlow(param: any) {
    return this.http.Post(this.prefix + 'Project/updateByIdForWorkFlow', param);
  }

  /**
   * 根据项目id自动生成一条新的发掘项目记录
   * @param projectId 项目ID
   */
  autoCopyProject(projectId: any, activitiKeyWord?: any) {
    return this.http.Get(this.prefix + 'Project/autoCopyProject?projectId=' + projectId + '&activitiKeyWord=' + activitiKeyWord);
  }

  /**
   * 根据ID批量删除项目表信息
   */
  deleteProjectBatch(param: any) {
    const url = this.prefix + 'Project/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 判断范围geometry数据合规性
   */
  validRange(evt: any) {
    const url = this.prefix + 'Project/validRange?geometry=' + evt;
    return this.http.Get(url);
  }

  /**
   * 根据id查询历史项目
   */
  getHistoryProjectById(projectId: any) {
    const url = this.prefix + 'Project/getByIdHistory/' + projectId;
    return this.http.Get(url);
  }

  /**
  * 修改历史项目
  */
  updateHistoryProject(param: any) {
    const url = this.prefix + 'Project/updateByIdHistory';
    return this.http.Post(url, param);
  }

  /**
   * 根据项目id更新项目流程信息
   * @param param
   */
  updateProcessInfoByProjectId(param: any, contractId?: any) {
    if (contractId) {
      const url = this.prefix + 'processInformation/updateByProjectId?contractId=' + contractId;
      return this.http.Post(url, param);
    } else {
      const url = this.prefix + 'processInformation/updateByProjectId';
      return this.http.Post(url, param);
    }
  }

  /**
   * 勘探发掘流程某四个节点生成发文稿附件
   * @param param
   */
  createManuscriptDoc(param: any) {
    const url = this.prefix + 'processInformation/createManuscriptDoc';
    return this.http.Post(url, param);
  }

  /**
 * 勘探发掘流程某四个节点生成发文稿附件-新流程
 * @param param
 */
  createManuscriptDocNew(param: any) {
    const url = this.prefix + 'processInformation/createManuscriptDocNew';
    return this.http.Post(url, param);
  }

  /**
   * 根据项目id查询流程信息表
   * @param projectId 项目id
   */
  queryByProjectId(projectId: string) {
    return this.http.Get(this.prefix + `processInformation/queryByProjectId/${projectId}`);
  }

  /**
   * 根据项目流程id获取信息
   * @param processInformation 项目流程id
   */
  queryProcessInfoById(processInformation: string) {
    return this.http.Get(this.prefix + `processInformation/queryById/${processInformation}`);
  }

  /**
 * 下载退款确认单
 * @param processInformationId
 */
  downLoadRefundConfirmation(processInformationId: string) {
    let url = this.prefix + 'processInformation/downLoadRefundConfirm?processInformationId=' + processInformationId;
    this.http.PostExport(url, null).subscribe(res => {
      if (res && res.status == 200) {
        if (res.body && res.body.size > 0) {
          let fileName = "退款确认单.docx";
          this.downloadFile(res.body, fileName);
        } else {
          this.message.danger("暂无可导出的数据");
        }
      }
    });
  }

  /**
   * 新增流程关联记录
   * @param projectId
   */
  saveChild(projectId: any, constructingUnitsName: any, projectName: any, contractArea: any, finishedArea: any, refundArea: any, unitName: any) {
    const url = this.prefix + 'processInformation/saveChild?projectId=' + projectId + '&constructingUnitsName=' + constructingUnitsName + '&projectName=' + projectName + '&contractArea=' + contractArea
      + '&finishedArea=' + finishedArea + '&refundArea=' + refundArea + '&unitName=' + unitName;
    return this.http.Post(url, null);
  }

  /**
   * 根据项目id或退款函id获取对应数据
   * @param projectId
   * @param explorationRefundId
   */
  queryChildById(projectId: any, explorationRefundId: any) {
    return this.http.Get(this.prefix + `processInformation/queryChildById?projectId=${projectId}&explorationRefundId=${explorationRefundId}`);
  }


  /**
 * 下载退款函
 * @param explorationRefundId
 */
  downLoadRefund(explorationRefundId: string) {
    let url = this.prefix + 'processInformation/downLoadRefund?explorationRefundId=' + explorationRefundId;
    this.http.PostExport(url, null).subscribe(res => {
      if (res && res.status == 200) {
        if (res.body && res.body.size > 0) {
          let fileName = "关于项目完结考古勘探工作及考古勘探经费退费的函.doc";
          this.downloadFile(res.body, fileName);
        } else {
          this.message.danger("暂无可导出的数据");
        }
      }
    });
  }

  /**
   * 修改【能否点击发起发掘流程的按钮】字段
   * @param projectId 项目id
   * @param canClickExc 0否 1是
   */
  updateCanClickExc(projectId: string, canClickExc: number) {
    const url = this.prefix + 'processInformation/updateCanClickExc?projectId=' + projectId + "&canClickExc=" + canClickExc;
    return this.http.Post(url, null);
  }

  /**
   * 判断能否点击发起发掘流程按钮
   * @param projectId
   */
  checkCanClickExc(projectId: string) {
    return this.http.Get(this.prefix + `processInformation/checkCanClickExc?projectId=${projectId}`);
  }

  /**
   * 流程中发出消息提醒
   * @param projectId 项目id
   * @param messageKey 消息类型唯一标识
   */
  sendProjectMessage(projectId: string, messageKey: string) {
    const url = this.prefix + 'processInformation/sendProjectMessage?projectId=' + projectId + "&messageKey=" + messageKey;
    return this.http.Post(url, null);
  }

  // 导入勘探档案的Excel
  importProjectExcel(evt: any) {
    let formData = new FormData();
    let passFile = evt.srcElement.files[0];
    formData.append('file', passFile);
    let headers = {
      'Content-Type': false,
      'processData': false,
      'Accept': 'application/json',
    }
    const url = this.prefix + 'Project/uploadExcel';
    return this.http.Post(url, formData, headers);
  }

  // 保存导入的数据
  saveProjectImportData(param: any) {
    const url = this.prefix + 'Project/saveImportData';
    return this.http.Post(url, param);
  }

  /**
   * 批量保存流程信息
   */
  saveProcessBatch(param: any) {
    const url = this.prefix + 'Process/saveBatch';
    return this.http.Post(url, param);
  }


  /**
   * 批量更新流程信息
   */
  updateProcessBatch(param: any) {
    const url = this.prefix + 'Process/updateBatchById';
    return this.http.Post(url, param);
  }

  /**
   * 批量删除流程信息
   */
  deleteProcessBatch(param: any) {
    const url = this.prefix + 'Process/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 查询流程信息列表
   */
  queryProcessList(param: any) {
    const url = this.prefix + 'Process/queryProcessList';
    return this.http.Post(url, param);
  }

  /**
   * 修改业务表审核状态字段
   * @param param 参数
   */
  updateAuditStatus(param: any) {
    const url = this.prefix + 'Project/updateAuditStatus';
    return this.http.Post(url, param);
  }

  /**
   * 根据项目id自动获取分配的勘探队伍id
   * @param projectId
   */
  getExplorationUnitId(projectId: any) {
    const url = this.prefix + 'distributionRecords/getExplorationUnitId?projectId=' + projectId;
    return this.http.Get(url);
  }

  /**
   * 根据项目id获取对应合作单位的组织id
   * @param projectId 项目id
   */
  getExplorationUnitOrganize(projectId: any) {
    const url = this.prefix + 'Project/getExplorationUnitOrganize/' + projectId;
    return this.http.Get(url);
  }

  /**
   * 分页查询勘探项目相关项目表
   * @param param 参数
   */
  queryPageListByUnits(param: any) {
    const url = this.prefix + 'Project/queryPageListByUnits';
    return this.http.Post(url, param);
  }

  /**
   * 分页查询项目立项跟踪表
   * @param param 分页查询参数
   */
  getProgressPageList(param: any) {
    const url = this.prefix + 'Project/getProgressPageList';
    return this.http.Post(url, param);
  }

  getInputRatePageList(param: any) {
    const url = this.prefix + 'Project/getInputRatePageList';
    return this.http.Post(url, param);
  }

  queryStandingBookPageList(param: any) {
    const url = this.prefix + 'Project/queryStandingBookPageList';
    return this.http.Post(url, param);
  }


  /**
   * 自动分配科室id
   */
  distributeOfficeId() {
    const url = this.prefix + 'Project/distributeOfficeId';
    return this.http.Get(url);
  }

  /**
   * 导出拨款申请
   * @param projectId
   */
  exportAppropriation(projectId: any) {
    let url = this.prefix + `Project/exportAppropriation?projectId=${projectId}`;
    this.http.PostExport(url, null).subscribe(res => {
      if (res && res.status == 200) {
        if (res.body && res.body.size > 0) {
          let fileName = "拨款申请.zip";
          this.downloadFile(res.body, fileName);
        } else {
          this.message.danger("暂无可导出的数据");
        }
      }
    });
  }

  //将请求返回的数据转化为Word文件并下载下来的方法
  downloadFile(fileBits: any, fileName: any) {
    /* 解决方法,使用 a链接下载,自己取文件名 */
    let elelink = document.createElement('a')
    elelink.download = fileName  //下载文件的文件名
    elelink.style.display = 'none'
    let file = new File([fileBits], null, { type: "application/octet-stream" })
    elelink.href = URL.createObjectURL(file)  //创建一个指向参数对象的URL
    document.body.appendChild(elelink)  //将创建的a标签设置为不可见,通过a标签链接进行下载,之后将a标签移除
    elelink.click()
    document.body.removeChild(elelink)
    URL.revokeObjectURL(URL.createObjectURL(file));  //不再需要已经创建的对象URL时,需要释放这个地址
  }

  /**
   * 根据补充协议id获取单条详细信息
   * @param id
   */
  querySupplementalAgreementById(id: string) {
    return this.http.Get(this.prefix + 'supplementalAgreement/queryById/' + id);
  }

  /**
   * 保存补充协议信息
   * @param param
   */
  saveSupplementalAgreement(param: any) {
    return this.http.Post(this.prefix + 'supplementalAgreement/save', param);
  }

  /**
     * 修改补充协议信息
     * @param param
     */
  updateSupplementalAgreement(param: any) {
    return this.http.Post(this.prefix + 'supplementalAgreement/update', param);
  }

  /**
   * 修改业务表审核状态字段
   * @param param 参数
   */
  updateSupplementalAgreementAuditStatus(param: any) {
    const url = this.prefix + 'supplementalAgreement/updateAuditStatus';
    return this.http.Post(url, param);
  }

  /**
   * 下载补充协议
   * @param supplementalAgreementId
   */
  downLoadSupplementalAgreement(supplementalAgreementId: string) {
    let url = this.prefix + 'supplementalAgreement/downLoad?supplementalAgreementId=' + supplementalAgreementId;
    this.http.PostExport(url, null).subscribe(res => {
      if (res && res.status == 200) {
        if (res.body && res.body.size > 0) {
          let fileName = "与勘探委托单位补充协议.doc";
          this.downloadFile(res.body, fileName);
        } else {
          this.message.danger("暂无可导出的数据");
        }
      }
    });
  }

  /**
   * 生成工作函对应的文档并上传
   * @param param
   */
  createWorkLetter(param: any) {
    const url = this.prefix + 'Project/createWorkLetter';
    return this.http.Post(url, param);
  }
  /***************************************************************导出Excel start**********************************************************************/

  /**
   * 导出Excel
   */
  exportAsExcel() {
    return this.prefix + 'Project/exportAsExcel';
  }

  /**
   * 导出台账
   */
  exportStandingBook() {
    return this.prefix + 'Project/exportStandingBook';
  }

  /**
   * 导出上会申请表
   */
  exportMeeting(param: any) {
    const url = this.prefix + 'Project/exportMeetings';
    return this.http.PostExport(url, param);
  }

  queryTimeList() {
    const url = this.prefix + 'Project/queryTimeList';
    return this.http.Get(url);
  }

  /***************************************************************导出Excel end**********************************************************************/



  /**
   * 获取文件策略
   * @param id
   */
  queryFileById(id: any) {
    const url = this.prefix + 'archiveData/queryFileById?id=' + id;
    return this.http.Get(url);
  }

  /**
   * 获取文件策略
   * @param id
   */
  queryFiles(id: any) {
    const url = this.prefix + 'archiveData/queryFile?id=' + id;
    return this.http.Get(url);
  }

  /**
   * 获取文件策略
   * @param id
   */
  queryReportById(projectId: any, type: Int16Array) {
    const url = this.prefix + 'archiveData/queryReportById?projectId=' + projectId + "&type=" + type;
    return this.http.Get(url);
  }

  /**
   * 获取流程相关文件
   * @param id
   */
  queryFile(id: any) {
    const url = this.prefix + 'archiveData/queryFile?id=' + id;
    return this.http.Get(url);
  }

  /**
   * 生成进度报告
   * @param projectId 项目id
   * @param type 项目类型 2勘探 3发掘
   */
  addReport(projectId: any, type: any) {
    const url = this.prefix + `scheduler/addReport/${projectId}/${type}`;
    return this.http.Post(url, null);
  }


  //终结项目审核流程
  endProgress(param: any) {
    const url = environment.activitiWebAPI + 'activitiRunTime/endAndStart?type=1';
    return this.http.Post(url, param);
  }

  //修改项目审核状态为完成
  completeProgress(param: any) {
    const url = this.prefix + 'Project/completeProgress?projectId=' + param;
    return this.http.Get(url);
  }

  //新增同步项目
  saveSyncProject(param: any) {
    const url = this.famfix + 'famSyncProject/save';
    return this.http.Post(url, param);
  }

  //修改审核状态
  updateSyncProjectStatus(param: any) {
    const url = this.famfix + 'famSyncProject/updateAuditStatus';
    return this.http.Post(url, param);
  }

  //审核成功后发起同步
  dataSyncSingleProject(param: any) {
    const url = this.famfix + 'dataSync/dataSyncSingleProject';
    return this.http.Post(url, param);
  }

  /**
   * 分页获取特殊项目表列表
   */
  queryApmSpecialProjectListByPage(param: any) {
    const url = this.prefix + 'apmSpecialProject/queryPageList';
    return this.http.Post(url, param);
  }


  /**
  * 获取特殊项目表列表(不分页)
  */
  queryApmSpecialProjectList(entity: any) {
    const url = this.prefix + 'apmSpecialProject/queryList';
    return this.http.Post(url, entity);
  }


  /**
   * 保存特殊项目表信息
   */
  saveApmSpecialProject(param: any) {
    const url = this.prefix + 'apmSpecialProject/save';
    return this.http.Post(url, param);
  }

  /**
   * 编辑特殊项目表信息
   */
  editApmSpecialProject(param: any) {
    const url = this.prefix + 'apmSpecialProject/update';
    return this.http.Post(url, param);
  }

  /**
   * 查询单个特殊项目表信息
   */
  queryApmSpecialProjectById(id: any) {
    const url = this.prefix + "apmSpecialProject/queryById/" + id;
    return this.http.Get(url);
  }

  /**
   * 删除特殊项目表
   */
  deleteApmSpecialProject(param: any) {
    const url = this.prefix + 'apmSpecialProject/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
* 获取地图完整配置信息(包括图层配置信息)
*/
  queryMapConfig(param: any) {
    const url = this.famfix + "agsLayerGroup/queryList";
    return this.http.Post(url, param);
  }

  /**
* 获取地图完整配置信息(包括图层配置信息)
*/
  queryMapConfigById(projectId: any) {
    const url = this.famfix + "agsMapConfig/queryConfig/" + projectId;
    return this.http.Get(url, null);
  }

  /**
  * 分页查询项目资料
  */
  queryFileDataByPage(param: any) {
    const url = this.prefix + "fileData/queryByPage";
    return this.http.Post(url, param);
  }

  /**
   * 分页查询项目资料-项目模式
   */
  queryFileDataProjectModeByPage(param: any) {
    const url = this.prefix + "Project/projectMode/queryPageList";
    return this.http.Post(url, param);
  }

  /**
   * 新增项目资料
   */
  saveFileData(param: any) {
    const url = this.prefix + "fileData/save";
    return this.http.Post(url, param);
  }

  /**
   * 删除项目资料
   */
  deleteFileData(param: any) {
    const url = this.prefix + "fileData/activitiReturnDelete";
    return this.http.Post(url, param);
  }

  /**
   * 删除单个项目资料
   */
  deleteFileDataById(param: any) {
    const url = this.prefix + "fileData/delete";
    return this.http.Post(url, param);
  }


  /**
   * 查询安技防信息
   */
  querySafetyTechApplicationById(id: any) {
    const url = this.prefix + "apmSafetyTechApplication/queryById/" + id;
    return this.http.Get(url);
  }

  /**
   * 根据项目id查询安技防信息
   */
  querySafetyTechApplicationByProjectId(projectId: any) {
    const url = this.prefix + "apmSafetyTechApplication/getInfoByProjectId?projectId=" + projectId;
    return this.http.Get(url);
  }

  /**
   * 保存安技防信息
   */
  saveSafetyTechApplication(param: any) {
    const url = this.prefix + "apmSafetyTechApplication/save";
    return this.http.Post(url, param);
  }

  /**
   * 修改安技防信息
   */
  updateSafetyTechApplication(param: any) {
    const url = this.prefix + "apmSafetyTechApplication/update";
    return this.http.Post(url, param);
  }

  /**
   * 查询安技防可用项目（无安技防数据并且有项目负责人的勘探项目）
   */
  querySafeTechOptionPageList(param: any) {
    const url = this.prefix + "Project/querySafeTechOptionPageList";
    return this.http.Post(url, param);
  }

  /**
  * 获取发掘委托合同信息列表
  */
  queryExcavateEntrustContractList(param: any) {
    const url = this.prefix + "contract/queryList";
    return this.http.Post(url, param);
  }

  /**
 * 查询发掘委托合同信息
 */
  queryExcavateEntrustContractById(id: any) {
    const url = this.prefix + "contract/queryById/" + id;
    return this.http.Get(url);
  }

  /**
   * 为项目创建或复用唯一的录入委托合同信息记录。
   * @param projectId 项目ID
   * @returns 包含新表ID和任务告知书只读字段的数据
   */
  prepareEntrustmentContractInformation(projectId: string) {
    const url = this.prefix + "contract/prepareEntrustmentContractInformation/" + projectId;
    return this.http.Post(url, {});
  }

  /**
   * 按新表主键查询录入委托合同信息。
   * @param entrustmentInformationId 录入委托合同信息ID
   * @returns 新表数据及已生成合同
   */
  queryEntrustmentContractInformation(entrustmentInformationId: string) {
    const url = this.prefix + "contract/queryEntrustmentContractInformation/" + entrustmentInformationId;
    return this.http.Get(url);
  }

  /**
   * 按项目阶段读取已保存的录入信息，供委托合同资料只读展示。
   * @param projectId 项目ID
   * @param projectStage 合同所属阶段，2为勘探、3为发掘
   * @returns 已保存的录入信息，无记录时data为null
   */
  queryEntrustmentContractInformationByProject(projectId: string, projectStage: string) {
    const url = this.prefix + "contract/queryEntrustmentContractInformationByProject/"
      + encodeURIComponent(projectId) + "/" + encodeURIComponent(projectStage);
    return this.http.Get(url);
  }

  /**
   * 保存录入委托合同信息。
   * @param param 录入信息ID、上会时间、面积及对应合同金额
   * @returns 保存后的合同和后续流程信息
   */
  saveEntrustmentContractInformation(param: EntrustmentContractInformationSave) {
    const url = this.prefix + "contract/saveEntrustmentContractInformation";
    return this.http.Post(url, param);
  }

  /**
  * 保存发掘委托合同信息
  */
  saveExcavateEntrustContract(param: any) {
    const url = this.prefix + "contract/save";
    return this.http.Post(url, param);
  }

  /**
  * 保存发掘委托合同信息
  */
  saveExcavateEntrustContractPro(param: any): Promise<any> {
    return new Promise((resolve) => {
      const url = this.prefix + "contract/save";
      this.http.Post(url, param)
        .subscribe((res) => {
          resolve(res);
        });
    });
  }

  /**
   * 修改发掘委托合同信息
   */
  updateExcavateEntrustContract(param: any) {
    const url = this.prefix + "contract/update";
    return this.http.Post(url, param);
  }

  /**
   * 获取任务告知书需进场时间范围
   */
  getNotificationApproachRule(projectId: string, taskId: string, documentType: number, historicalProjectSupplement: boolean = false) {
    const url = this.prefix + "processInformation/notificationApproachRule?projectId="
      + encodeURIComponent(projectId) + "&taskId=" + encodeURIComponent(taskId)
      + "&documentType=" + documentType + "&historicalProjectSupplement=" + historicalProjectSupplement;
    return this.http.Get(url);
  }

  /** 获取工作日 */
  getLatestWorkday(date: any, days: any) {
    const url = this.prefix + "common/getLatestWorkday?date=" + date + "&days=" + days;
    return this.http.Get(url);
  }

  /**
   * 删除已生成的文件
   */
  deleteCreateFile(param: any) {
    const url = this.prefix + "fileData/deleteFile";
    return this.http.Post(url, param);
  }

  /**
   * 查询台账
   */
  queryLedgerPageList(param: any) {
    const url = this.prefix + "contractLedger/queryPageList";
    return this.http.Post(url, param);
  }


}
